"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _styles = require("@mui/material/styles");
var _bcmKunrenActions = require("../bcmKunrenActions");
var _KunrenInfoField = _interopRequireDefault(require("../common/components/KunrenInfoField"));
var _ScenarioGuidanceField = _interopRequireDefault(require("./components/ScenarioGuidanceField"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
var Yup = _interopRequireWildcard(require("yup"));
var _Consts = require("../common/consts/Consts");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const FieldSpace = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1)
  };
});

/**
 * 訓練実施要領・訓練シナリオ登録　登録
 */
const KunrenGuidanceEntry = props => {
  const {
    intl,
    callAPI,
    goMain,
    checkDirty,
    setDirty,
    setEntries,
    setContent,
    openConfirm,
    openInfoBar,
    changeScenario,
    setEntry,
    kunrenInfo,
    guidanceEntry
  } = props;
  const [isCustomCheck, setIsCustomCheck] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    if (kunrenInfo) {
      callAPI(_APIs.BCM_KUNREN_GUIDANCE, kunrenInfo).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setEntries(response.data);
        }
      });
    }
    window.scrollTo(0, 0);
  }, [callAPI, kunrenInfo, setEntries]);
  const schema = (0, _react.useMemo)(() => {
    return Yup.object({
      scenarioPolicyCd: (0, _validationHelpers.requiredSelect)(intl),
      exercisesDtRequiredFlag: (0, _validationHelpers.optionalBoolean)(),
      // 一時保存時（exercisesDtRequiredFlag=false）は未入力許容、登録時は必須
      exercisesDt: (0, _validationHelpers.requiredWhen)(intl, 'exercisesDtRequiredFlag', f => !!f, (0, _validationHelpers.dateOrEmpty)(intl)),
      // 文字列（trim＋空は未入力扱い）＋最大1000
      riskDetailNotes: (0, _validationHelpers.optionalStringTrimMax)(intl, 1000),
      kunrenPurpose: (0, _validationHelpers.optionalStringTrimMax)(intl, 1000),
      kunrenContent: (0, _validationHelpers.optionalStringTrimMax)(intl, 1000),
      supplement: (0, _validationHelpers.optionalStringTrimMax)(intl, 1000),
      // 対象リスクは、登録時（isCustomCheck=true）かつ シナリオ方針が「個別」または未選択のときのみ必須
      checkStatusList: Yup.array().nullable().test('tgt-risk-required', intl.formatMessage({
        id: _labelConsts.LABEL.CORE_PLEASE_SELECT
      }), function (list) {
        const {
          scenarioPolicyCd,
          exercisesDtRequiredFlag
        } = this.parent || {};
        if (!exercisesDtRequiredFlag) return true; // 一時保存時は未チェック許容
        if (!(scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !scenarioPolicyCd)) return true;
        if (!Array.isArray(list)) return false;
        return list.some(item => {
          if (item.checkKbn !== _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01) return false;
          if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
            return !!(item.notes && String(item.notes).trim() !== '');
          }
          return item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1;
        });
      }).test('tgt-risk-other-notes-length', intl.formatMessage({
        id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
      }, {
        0: 10
      }), function (list) {
        if (!Array.isArray(list)) return true;
        for (const item of list) {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
            if (item.notes && String(item.notes).length > 10) return false;
          }
        }
        return true;
      })
    });
  }, [intl]);
  const {
    handleSubmit,
    setValue,
    reset,
    formState: {
      errors
    }
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues: {
      scenarioPolicyCd: guidanceEntry.scenarioPolicyCd,
      exercisesDt: guidanceEntry.exercisesDt,
      exercisesDtRequiredFlag: isCustomCheck,
      riskDetailNotes: guidanceEntry.riskDetailNotes,
      kunrenPurpose: guidanceEntry.kunrenPurpose,
      kunrenContent: guidanceEntry.kunrenContent,
      supplement: guidanceEntry.supplement,
      checkStatusList: guidanceEntry.checkStatusList
    },
    shape: schema,
    mode: 'onSubmit',
    reValidateMode: 'onSubmit'
  });

  // Redux -> RHF 同期（外部状態が変わったらRHFへ反映）
  (0, _react.useEffect)(() => {
    reset({
      scenarioPolicyCd: guidanceEntry.scenarioPolicyCd,
      exercisesDt: guidanceEntry.exercisesDt,
      exercisesDtRequiredFlag: isCustomCheck,
      riskDetailNotes: guidanceEntry.riskDetailNotes,
      kunrenPurpose: guidanceEntry.kunrenPurpose,
      kunrenContent: guidanceEntry.kunrenContent,
      supplement: guidanceEntry.supplement,
      checkStatusList: guidanceEntry.checkStatusList
    }, {
      keepErrors: true,
      keepDirty: true,
      keepTouched: true,
      keepIsSubmitted: true
    });
  }, [guidanceEntry, isCustomCheck, reset]);

  // 会社／組織・シナリオ方針の変更時（API連動）
  const changeScenarioPolicy = value => {
    setDirty(true);
    setEntry('scenarioPolicyCd')(value);
    setValue('scenarioPolicyCd', value, {
      shouldValidate: false,
      shouldDirty: false
    });
    if (value !== _CodeConsts.CODE.BCM_SCENARIO.CODE_03) {
      const searchCondition = {
        targetCd: kunrenInfo.targetCd,
        bcmKaishaSoshikiCd: kunrenInfo.bcmKaishaSoshikiCd,
        scenarioPolicyCd: value
      };
      callAPI(_APIs.BCM_KUNREN_GUIDANCE_SCENARIO, searchCondition).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          changeScenario(response.data);
          // リスト刷新をRHFへも同期
          setValue('checkStatusList', response.data.checkStatusList, {
            shouldValidate: false,
            shouldDirty: false
          });
        }
      });
    }
  };

  // 削除処理
  const onDelete = () => {
    const sendData = {
      targetCd: kunrenInfo.targetCd,
      bcmKaishaSoshikiCd: kunrenInfo.bcmKaishaSoshikiCd,
      bcpTgtJigyoCd: kunrenInfo.bcpTgtJigyoCd,
      documentKindCd: _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJY
    };
    callAPI(_APIs.BCM_KUNREN_GUIDANCE_DELETE, sendData).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setContent(_bcmKunrenActions.CONTENTS.GUIDANCE_DELETE);
        setDirty(false);
      }
    });
  };

  // 削除ボタン押下時ダイアログ表示
  const openDeleteDialog = () => {
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: _labelConsts.LABEL.CORE_DELETE_CONFIRM_MESSAGE
    }), onDelete);
  };

  // 登録処理（フォーム有効時にConfirmを開く）
  const onValid = () => {
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: isCustomCheck ? _labelConsts.LABEL.CORE_REGISTER_CONFIRM_MESSAGE : _labelConsts.LABEL.CORE_TEMPORARILY_SAVED_CONFIRM_MESSAGE
    }), () => {
      const sendData = _objectSpread(_objectSpread({}, guidanceEntry), {}, {
        targetCd: kunrenInfo.targetCd,
        bcmKaishaSoshikiCd: kunrenInfo.bcmKaishaSoshikiCd,
        bcpTgtJigyoCd: kunrenInfo.bcpTgtJigyoCd,
        documentKindCd: _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJY
      });
      if (isCustomCheck) {
        callAPI(_APIs.BCM_KUNREN_GUIDANCE_REGISTER, sendData).then(response => {
          if (response.status === _APIs.STATUS.SUCCESS) {
            setDirty(false);
            setContent(_bcmKunrenActions.CONTENTS.GUIDANCE_RESULT);
          }
        });
      } else {
        callAPI(_APIs.BCM_KUNREN_GUIDANCE_SAVE, sendData).then(response => {
          if (response.status === _APIs.STATUS.SUCCESS) {
            setDirty(false);
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.SUCCESS, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_TEMP_STORE_MESSAGE
            }, {
              0: props.getCodeName(_CodeConsts.CODE.DOCUMENT_KIND.KBN, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJY)
            }));
            goMain(true);
          }
        });
      }
    });
  };
  const onInvalid = () => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  };

  // 送信ボタン押下時の事前ハンドラ（登録/一時保存の切り替え＋必須フラグ同期）
  const onClickBeforeSubmit = reg => () => {
    setIsCustomCheck(reg);
    setValue('exercisesDtRequiredFlag', reg, {
      shouldValidate: false,
      shouldDirty: false
    });
  };

  // 子での外部状態同期用（ReduxとRHFを同時に更新するヘルパ）
  const onChangeField = key => value => {
    setDirty(true);
    setEntry(key)(value);
    setValue(key, value, {
      shouldValidate: false,
      shouldDirty: false
    });
  };

  // checkStatusList の更新（配列書き換え時にRHFへも同期）
  const onChangeCheckStatusList = newList => {
    setDirty(true);
    setEntry('checkStatusList')(newList);
    setValue('checkStatusList', newList, {
      shouldValidate: false,
      shouldDirty: false
    });
  };
  const returnButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: () => checkDirty(() => goMain(false)),
    autoWidth: true,
    negative: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
  }));
  const deleteButton = guidanceEntry.kunrenProgressCd !== _CodeConsts.CODE.BCM_KR_PROG_CD.CODE_0 ? /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: openDeleteDialog,
    autoWidth: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_DELETE
  })) : null;
  const saveButton = guidanceEntry.kunrenProgressCd !== _CodeConsts.CODE.BCM_KR_PROG_CD.CODE_1 ? /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: onClickBeforeSubmit(false),
    submit: true,
    autoWidth: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_TEMP_STORE
  })) : null;
  const registerButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: onClickBeforeSubmit(true),
    submit: true,
    autoWidth: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REGISTER
  }));
  const actions = [returnButton];
  if (deleteButton) actions.push(deleteButton);
  if (saveButton) actions.push(saveButton);
  actions.push(registerButton);
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.BCM_BCP_KUNREN_GUIDANCE
    }),
    actions: actions,
    fixedWidth: true
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_KunrenInfoField.default, {
    data: kunrenInfo
  }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(FieldSpace, null, /*#__PURE__*/_react.default.createElement(_ScenarioGuidanceField.default, {
    guidanceEntry: guidanceEntry,
    setEntry: onChangeField,
    kunrenInfo: kunrenInfo,
    changeScenarioPolicy: changeScenarioPolicy,
    isCustomCheck: isCustomCheck,
    errors: errors,
    setFormValue: setValue,
    setCheckStatusList: onChangeCheckStatusList
  })))))));
};
const mapStateToProps = state => ({
  kunrenInfo: state.bcmKunren.kunrenInfo,
  guidanceEntry: state.bcmKunren.guidanceEntry,
  guidanceErrMsg: state.bcmKunren.guidanceErrMsg
});
const mapDispatchToProps = dispatch => {
  return {
    goMain: doSearch => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.GO_MAIN](doSearch)),
    setEntry: key => value => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_GUIDANCE_ENTRY](key, value)),
    setEntries: guidanceEntry => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_GUIDANCE_ENTRIES](guidanceEntry)),
    changeScenario: guidanceEntry => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.CHANGE_SCENARIO](guidanceEntry)),
    setGuidanceErrMsg: key => value => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_GUIDANCE_ERR_MSG](key, value)),
    resetGuidanceErrMsg: () => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.RESET_GUIDANCE_ERR_MSG]()),
    setContent: content => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_CONTENT](content)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    setDirty: dirty => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](dirty))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)((0, _CallAPI.withCallAPI)(KunrenGuidanceEntry))));